// FormFactory.js

import $ from 'jquery';

import BaseVisualControlFactory from 'BaseVisualControlFactory.js';
import constants        from 'Constants.js';
import ThemeModel       from 'ThemeModel.js';
import FormView 		from 'form/FormView.js';
import listService      from 'ListService.js';
//=============================================================================
//
// Creates the form. It has its own model. That model obtains its own initial
// properties.
//
// -Lou Mauget, December 17, 2015
//
//=============================================================================
class FormFactory extends BaseVisualControlFactory {
	view;

	constructor () {
		super();
	}
	
	// Making the layout_frame value the default one as this class 
	// can be reused for the rest of the view types(Behaviors and Workflow)
	createView( factoryKey = 'layout_frame', formProperties) {
		let attributes = this.createChildAttributes(  factoryKey ) ;
		attributes.isYodaFile = true;
		attributes.formWidth = !formProperties ? '500' : formProperties.width;
 		attributes.formHeight = !formProperties ? '400' : formProperties.height;
		attributes.sizePreset = '';
		attributes.unit = 'pixel';
		attributes.instanceName = '';
		attributes.TextOrNumber = '';
		attributes.ValueOfAField = '';
		attributes.Special =  '';
		attributes.Formula =  '<empty>';
		attributes.centerVertical = 'true';
		attributes.centerHorizontal = 'true';
		attributes.outsideColor = !formProperties ? '#EEEEEE' : formProperties.outsideColor;
		attributes.mobileOutsideColor = '';
		attributes.frame = false;
		attributes.frameRoundCorners =  true;
		attributes.frameSize = '16';
		attributes.frameColor =  '#66CCFF';
		attributes.pageTopScroll =  'false';
		attributes.pageEffect = 'none';
		attributes.rtl = '';
		attributes.timeOut =  '30';
		attributes.showNameOfLockingUser = 'true';
		attributes.confirmBrowserClose = 'true';
		attributes.viewingState = '';
		attributes.startPage = '';
		attributes.sharedSettingsTitle = 'App Shared Settings';
		attributes.displayMode = '';
		attributes.responsive = false;
		attributes.minWidth = 100;
		attributes.minHeight = 100;
		attributes.displayCenterSettings = 'block';
		attributes.displayShadowSettings = 'block';
		attributes.translateProps= [ {key:"title", label:"App Title"} ];
		attributes.focusColor =  '#005FCC';
		
		let formId = 'aForm';

		// If we have a workflow frame we should add default role values to the view properties.
		if(factoryKey === 'workflow_frame'){
			attributes.gridData = [
				{'name':'Role 1', 'defaultPerson': ''},
				{'name':'Role 2', 'defaultPerson': ''},
				{'name':'Role 3', 'defaultPerson': ''}
			];
		}

		

		this.view = new FormView( { model: new ThemeModel( attributes), el: $(constants.FORM_ID),
			id: formId, factoryKey: factoryKey} );

		return this.view;
	}

	remove(){
		this.view.remove();
		super.remove();
	}
}

const formFactory = new FormFactory();
export default formFactory;
